import React, { Component } from 'react';

import { Button } from 'devextreme-react/button';
import { Link } from "react-router-dom";

import { TbSquareRoundedArrowRight } from 'react-icons/tb';

import AntLocalization from '../utils/AntLocalization';

export default function (props) {
    return (
        <React.Fragment>
            <Button
                className="ant-link-in-form"
                width="100%"
                onClick={() => {
                    if (props.onClick)
                        props.onClick({
                            field: props.field,
                            text: AntLocalization.translateText(props.text),
                            value: props.value
                        });
                }}
                type="normal"
                stylingMode="outlined"
                hoverStateEnabled={false}
                focusStateEnabled={false}
                activeStateEnabled={false}
            >
                <Link className="ant-link-in-form" to={props.linkUrl ? props.linkUrl : '/home'} style={{ textDecoration: 'none' }}>
                    {/* <i className={'dx-icon dx-icon-import'}></i> */}
                    <TbSquareRoundedArrowRight className={'dx-icon'} />
                    {AntLocalization.translateText(props.text)}
                </Link>
            </Button>
        </React.Fragment>
    );
}
